import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'
import { useFeatureFlag } from '@fs/zion-flags'

export default function useFamAppsLinks({ isCoreLanguage, nonReligiousMode, canAddPersonalData }) {
  const { t } = useTranslation()
  const { isOn: showDiscoveryTogetherLink } = useFeatureFlag('home_fatFooter_discoveryTogetherLink')

  return {
    id: 'famApps',
    title: t('nav.famApps', 'FamilySearch Apps'),
    nonReligiousmode: null,
    hidden: nonReligiousMode || !canAddPersonalData,
    subNav: [
      {
        id: 'famTreeApp',
        text: t('nav.links.famApps.famTreeApp', 'Family Tree App'),
        url: `/${i18n.language}/mobile-apps/family-tree-app`,
        linkName: 'ff_famApps_famTreeApp',
        dataTestId: 'ff_family_tree_app',
        isNew: false,
      },
      {
        id: 'memApp',
        text: t('nav.links.famApps.memApp', 'Memories App'),
        url: `/memories/`,
        linkName: 'ff_famApps_memApp',
        dataTestId: 'ff_memories_app',
        isNew: false,
      },
      {
        id: 'getInvApp',
        text: t('nav.links.famApps.getInvApp', 'Get Involved App'),
        url: '/getinvolved/',
        linkName: 'ff_famApps_getInvApp',
        dataTestId: 'ff_get_involved_app',
        isNew: false,
        hidden: !isCoreLanguage,
      },
      {
        id: 'togetherApp',
        text: t('nav.links.famApps.togetherApp', 'Together App'),
        url: '/discovery/together',
        linkName: 'ff_famApps_togetherApp',
        dataTestId: 'ff_together_app',
        isNew: true,
        hidden: !showDiscoveryTogetherLink || !isCoreLanguage,
      },
      {
        id: 'allApps',
        text: t('nav.links.famApps.allApps', 'All Mobile Apps'),
        url: `/${i18n.language}/mobile-apps/`,
        linkName: 'ff_famApps_allFSApps',
        dataTestId: 'ff_all_mobile_apps',
        isNew: false,
      },
    ],
  }
}
